// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { useMemo, useEffect, createContext, useContext } from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Link, useLocation } from 'react-router-dom';
import Pagination from '@mui/material/Pagination';
//import Ts from "./TS.tsx";
import { useIntl, FormattedMessage } from 'react-intl';
import ReactGA from "react-ga4";
import Refresh from './components/refresh';
import { LoginContext, AuthContext, LoadingContext, InfoPrewContext } from '../Default';
import {
  MRT_EditActionButtons,
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';
import { colors } from '@mui/material';
//import { data, type Person } from './makeData';
import { type C2List, type Notice } from "./data/tdb_c2";
import './TS.css';
import Chip from '@mui/material/Chip';
import { MRT_Localization_JA } from 'material-react-table/locales/ja';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { stix } from './data/tdb_c2.tsx';
import logo from '../../TIP_tate.svg';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {
  Tooltip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import dayjs, { Dayjs } from 'dayjs';
import { v4 as uuidv4 } from 'uuid';
//import {RefreshContext} from './SearchResult';
// Google Analytics 測定 ID を入力して設定
ReactGA.initialize(process.env.REACT_APP_GA_KEY);
// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));
//export const RefreshContext = createContext();
const handleReady = () => {

};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = () => {
      reject(new Error('Failed to read the file.'));
    };
    reader.readAsDataURL(file);
  });
}

function getStyles(name: string, tag: readonly string[], theme: Theme) {
  return {
    fontWeight:  theme.typography.fontWeightMedium
  };
}
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));
const StyledBox = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  width: '100%',
  height: 400,
  marginTop: theme.spacing(8),
  borderRadius: theme.shape.borderRadius,
  outline: '1px solid',
  boxShadow: '0 0 12px 8px hsla(220, 25%, 80%, 0.2)',
  backgroundImage: `url(${'/static/images/templates/templates-images/hero-light.png'})`,
  outlineColor: 'hsla(220, 25%, 80%, 0.5)',
  backgroundSize: 'cover',
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(10),
    height: 700,
  },
  ...theme.applyStyles('dark', {
    boxShadow: '0 0 24px 12px hsla(210, 100%, 25%, 0.2)',
    backgroundImage: `url(${'/static/images/templates/templates-images/hero-dark.png'})`,
    outlineColor: 'hsla(210, 100%, 80%, 0.1)',
  }),
}));
const styles = (theme: { spacing: { unit: number; }; shape: { borderRadius: any; }; breakpoints: { up: (arg0: string) => any; }; transitions: { create: (arg0: string) => any; }; }) => ({
  root: {
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit,
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 120,
      '&:focus': {
        width: 200,
      },
    },
  },
});
const validateRequired = (value: string) => !!value.length;
function isScriptAlreadyInserted(scriptElement) {
  return Array.from(document.querySelectorAll('script')).some(s => s.src === scriptElement.src)
}
function validateUser(user: User) {
  return {
    name: !validateRequired(user.link)
      ? '必須です'
      : '',
  };
}
function validateUser2(user: User) {
  return {
    name: !validateRequired(user.name)
      ? '必須です'
      : '',
  };
}

export default function MaintenanceNews() {
  const intl = useIntl();
  let locale;
  if (intl.locale == "ja") {
    locale = MRT_Localization_JA
  } else {
    locale = MRT_Localization_EN
  }
  const location = useLocation();
  const [category, setCategory] = React.useState(location.state !== null && location.state.hasOwnProperty("category") ? location.state["category"] : "0");
  const [keyword, setKeyword] = React.useState(location.state !== null && location.state.hasOwnProperty("keyword") ? location.state["keyword"] : "");
  //const [refreshKey, setRefreshKey] = React.useState(0);
  //const [isActive, setIsActive] = useState(false);
  //const [category] = React.useState(location.state["category"]);
  //const [keyword] = React.useState(location.state["keyword"]);
  const [posts, setPosts] = React.useState<Post[]>([]);
  const [posts2, setPosts2] = React.useState<Post[]>([]);
  const [posts3, setPosts3] = React.useState<Post[]>([]);
  const [posts4, setPosts4] = React.useState<Post[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const { login, setLogain } = useContext(LoginContext);
  const { auth, setAuth } = useContext(AuthContext);
  const { loading, setLoading } = useContext(LoadingContext);
  const { noticeTitle, setNoticeTitle, noticeMsg, setNoticeMsg, noticeMsgOpen, setNoticeMsgOpen, setNoticeDate } = useContext(InfoPrewContext);
  const [reload, setReload] = React.useState(0);
  const [keyword2, setKeyword2] = React.useState(location.state !== null && location.state.hasOwnProperty("keyword") ? location.state["keyword"] : intl.formatMessage({ id: "langID00089" }));
  const [checked1, setChecked1] = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);
  const [defaultValue1, setDefaultValue1] = React.useState("aaa");
  const [thumbnail, setThumbnail] = React.useState(location.state !== null && location.state.table.hasOwnProperty("thumbnail") ? location.state.table["thumbnail"] : "");
  const [mok, setMok] = React.useState(location.state !== null && location.state.hasOwnProperty("category") && location.state["category"] !== "find" ? true : false);
  const [mok2, setMok2] = React.useState(true);
  const [image, setImage] = React.useState<File>()
  const [open1, setOpen1] = React.useState(false);
  const [ErrMs, setErrMs] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const [open5, setOpen5] = React.useState(false);
  const [preTitle, setPreTitle] = React.useState("");
  const [preDescription, setPreDescription] = React.useState("");
  const [preContent, setPreContent] = React.useState("");
  const [preLink, setPreLink] = React.useState("");
  const [pageCount, setPageCount] = React.useState(1);
  const [page, setPage] = React.useState(1);
  const [link, setLink] = React.useState("");

  const theme = useTheme();
  const [tag, setTag] = React.useState<string[]>(location.state !== null && location.state.table.hasOwnProperty("tag") ? location.state.table["tag"] : []);
  const [validationErrors, setValidationErrors] = React.useState<

    Record<string, string | undefined>
  >({});

    const handleChangePage = (event, index) => {
    //ページ移動時にページ番号を更新
    setPage(index);
    getFeed(link,index)
  }
    const getRss = async (URL): Promise<Post[]> => {
    const url = process.env.REACT_APP_RSS_API_URL;
    try {
      let bodyData;
        bodyData = {
          category: "19",
          keyword: URL
        };


      var getParams = new URLSearchParams(params);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      var params_str = params.toString();
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            setLoading(false);
            throw new Error('status is not 200');
          }
          return response.json();

// const text =await response.text();

//           return response.json();
        })
        .then(jsondata => {
          setLoading(false);
              const feed = jsondata;
              setPreTitle(feed.items[0].title);
              setPreContent(feed.items[0].content);
              setPreDescription(feed.items[0].description);
              setPreLink(feed.items[0].url);
          return feed;
        })
        .catch(error => {
          setLoading(false);
        });;
      setLoading(false);
    } catch {
      setLoading(false);
    }
}

  //const {refreshKey, setRefreshKey} = useContext(RefreshContext);
  const resData3 = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_COLUMN_API_URL;
    try {
      let bodyData = {
        category: "9"
      };
      var getParams = new URLSearchParams(params);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      var params_str = params.toString();
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            setLoading(false);
            throw new Error('status is not 200');
          }
          return response.json();
        })
        .then(jsondata => {
          setLoading(false);
          return jsondata;
        })
        .catch(error => {
          setLoading(false);
        });;
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  async function getTag() {
    const data3 = await resData3();
    setPosts3(data3);
    setLoading(false);
  }
  async function getFeed(link,index) {
    const data4 = await resData2(link,index);
      if(data4.length == 0){
        setPageCount(1);
      }else{
        setPageCount(Math.ceil(data4[0].count/10));
      }
    setPosts2(data4);
    setLoading(false);
  }
  async function getRssFunc(URL) {
    const data3 = getRss(URL);

  }
  //CREATE action
  const handleCreateUser2: MRT_TableOptions<User>['onCreatingRowSave'] = async ({
    values,
    table,
  }) => {
    const newValidationErrors = validateUser2(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      setMsg("langID00075");
      setMsgOpenErr(true);
      setTimeout(() => {
        setMsgOpenErr(false);
      }, 5000);
      return;
    }
    setValidationErrors({});
    const url = process.env.REACT_APP_COLUMN_API_URL;
    try {
      let bodyData = {
        category: "10",
        id: uuidv4(),
        name: values.name
      };
      var getParams = new URLSearchParams(params);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      var params_str = params.toString();
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            setLoading(false);
            throw new Error('status is not 200');
          }
          return response.json();
        })
        .then(jsondata => {
          setLoading(false);
          getTag();
          table.setCreatingRow(false)
        })
        .catch(error => {
          setLoading(false);
        });
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }

  };

  //UPDATE action
  const handleSaveUser2: MRT_TableOptions<User>['onEditingRowSave'] = async ({
    values,
    table,
    row
  }) => {
    const newValidationErrors = validateUser2(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});
    const url = process.env.REACT_APP_COLUMN_API_URL;
    try {
      let bodyData = {
        category: "11",
        id: row.original.id,
        name: values.name
      };
      var getParams = new URLSearchParams(params);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      var params_str = params.toString();
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            setLoading(false);
            throw new Error('status is not 200');
          }
          return response.json();
        })
        .then(jsondata => {
          setLoading(false);
          getTag();
          table.setEditingRow(null);
        })
        .catch(error => {
          setLoading(false);
        });
      setLoading(false);
    } catch {
      setLoading(false);
    }

  };

  //DELETE action
  const openDeleteConfirmModal2 = (row: MRT_Row<User>) => {
    if (window.confirm('本当に削除してもよろしいでしょうか')) {
      const url = process.env.REACT_APP_COLUMN_API_URL;
      try {
        let bodyData = {
          category: "12",
          id: row.original.id
        };
        var getParams = new URLSearchParams(params);
        const headers = new Headers({
          "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
          'Access-Control-Allow-Credentials': 'true'
        });
        var params_str = params.toString();
        setLoading(true);
        return fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(bodyData)
        })
          .then((response) => {
            if (!response.ok) {
              setLoading(false);
              throw new Error('status is not 200');
            }
            return response.json();
          })
          .then(jsondata => {
            setLoading(false);
            getTag();
          })
          .catch(error => {
            setLoading(false);
          });
        setLoading(false);
      } catch {
        setLoading(false);
      }
    }
  };



  // const value = {
  //   refreshKey,
  //   setRefreshKey,
  // };
  const handleUpload = () => {
    handleUploadSend().then((response) => {
      if (!response.ok) {
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    });
  };

  // 画像をサーバーにアップロードする関数
  async function uploadImage(fileList) {
    const formData = new FormData();
    const url = process.env.REACT_APP_COLUMN_API_URL;
    formData.append('image', fileList[0]);
    if (fileList[0] || thumbnail !== "") { // file が undefined でないことを確認
      let bodyData;
      // BufferをBase64文字列に変換
      const base64 = await convertToBase64(fileList[0]);
      noteRef.current.summernote("insertImage", base64, fileList[0].name);
      bodyData = {
        category: "16",
        img: base64,
      };
      const formData = new FormData();
      formData.append('file', base64);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      // setLoading(true);
      // return fetch(url, {
      //     method: 'POST',
      //     headers: headers,
      //     body: JSON.stringify(bodyData)
      //   })
      //   .then((response) => {
      //     if (!response.ok ){
      //       setLoading(false);
      //       throw new Error('status is not 200');
      //     }
      //     return response.json();
      //   })
      //   .then(jsondata => {
      //     console.log(response);
      //     noteRef.current.summernote("insertImage", jsondata.url, fileList[0].name);
      //   })
    } else {
      alert(`ファイルが選がされていません。`)
      return null;
    }
  };
  async function handleUploadSend(img) {
    const url = process.env.REACT_APP_COLUMN_API_URL;
    setThumbnail("");
    if (img) { // file が undefined でないことを確認
      const formData = new FormData();
      formData.append('image', img);
      let bodyData;
      // BufferをBase64文字列に変換
      const base64 = await convertToBase64(img);
      setThumbnail(base64);
      //const base64String = imageBuffer.toString('base64');
      bodyData = {
        category: "16",
        img: base64,
      };

      formData.append('file', img);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });

    } else {
      alert(`ファイルが選択されていません。`)
      return null;
    };
  }

  const getImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return
    const img: File = e.target.files[0]
    setImage(img)
    handleUploadSend(img);
  }
  const tagChange = (event: SelectChangeEvent<typeof tag>) => {
    const {
      target: { value },
    } = event;
    setTag(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  function onChange(content: any) {
    setTextareaContents(content);
    let contentSub = content.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
    setTextareaContentsSub(contentSub);
  };
  const tagManage = () => {
    setOpen4(true);
  }
  const returnButton = document.getElementById("returnButton");
  const saveColumn = async () => {
    if (title != "" && thumbnail != "" && createDate != "" && startDate) {
      await saveColumnFunc("");
      setMsg("langID00072");
      setMsgOpen(true);
      setTimeout(() => {
        setMsgOpen(false);
      }, 5000);
      returnButton?.click();
      return true;
    }
    setMsg("langID00073");
    setMsgOpenErr(true);
    setTimeout(() => {
      setMsgOpenErr(false);
    }, 5000);
    return false;
  }

  const saveTempColumn = async () => {
    if (title != "") {
      await saveColumnFunc("temp");
      setMsg("langID00072");
      setMsgOpen(true);
      setTimeout(() => {
        setMsgOpen(false);
      }, 5000);
      returnButton?.click();
      return true;
    }
    setMsg("langID00074");
    setMsgOpenErr(true);
    setTimeout(() => {
      setMsgOpenErr(false);
    }, 5000);
    return false;
  }
  const deleteColumn = async () => {
    await saveColumnFunc("del");
    setOpen1(false);
    const returnButton = document.getElementById("returnButton");
    setMsg("langID00072");
    setMsgOpen(true);
    setTimeout(() => {
      setMsgOpen(false);
    }, 5000);
    returnButton?.click();
    return true;
  }

  const handleChangeCheckBox1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked1(event.target.checked);
  };

  const handleChangeCheckBox2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked2(event.target.checked);
  };
  const handleChange = (event: SelectChangeEvent) => {
    setCategory(event.target.value);

  }
  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value);
  }
  const handleChangedefaultInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDefaultValue1(event.target.value);
  }

  const createColumn = () => {
    const cc = document.getElementById("createColumn");
    cc?.click();

  }

  const handleDialogClose4 = () => {
    setOpen4(false);
  };
  const handleDialogClose5 = () => {
    setOpen5(false);
  };
  const reloadChange = () => {
    if (keyword == "") {
      setKeyword2(intl.formatMessage({ id: "langID00089" }));
    } else {
      setKeyword2(keyword);
    }
    const i = reload + 1;
    setReload(i);
  }

  const params = { // 渡したいパラメータをJSON形式で書く
    category: category,
    keyword: keyword
  };
  var getParams = new URLSearchParams(params);
  // TextfieldとButtonIconを合体させたコンポーネントの作成
  const AddButton = () => {
    const addButtonClick = () => {

      // document.getElementById("demo-form").submit();
      ReactGA.event({
        category: "Search Button",
        action: "Search Button",
        label: keyword, // Optional
      });
      //const aaa = document.getElementById("sc");
      //aaa?.click();
      reloadChange();
      //setRefreshKey(old => old + 1)
    };
    return (
      <IconButton onClick={() => addButtonClick()}>
        <SearchIcon />
      </IconButton>
    );
  };
  //const {refreshKey, setRefreshKey} = useContext(RefreshContext);
  const resData = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_RSS_API_URL;
    try {
      let bodyData;
      if (keyword == "") {
        bodyData = {
          category: "3",
          keyword: keyword
        };
      } else if (keyword.indexOf("#") === 0) {
        const keywordSub = keyword.replace("#", "");
        bodyData = {
          category: "3",
          keyword: keywordSub
        };
      } else {
        bodyData = {
          category: "3",
          keyword: keyword
        };
      }

      var getParams = new URLSearchParams(params);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      var params_str = params.toString();
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            setLoading(false);
            throw new Error('status is not 200');
          }
          return response.json();
        })
        .then(jsondata => {
          setLoading(false);
          return jsondata;
        })
        .catch(error => {
          setLoading(false);
        });;
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async function () {
      var res = [];
      const data = await resData();
      setPosts(data);
      setLoading(false);
      getTag();
    })();
  }, [reload]);
  const resData2 = async (link,index): Promise<Post[]> => {
  const url = process.env.REACT_APP_RSS_API_URL;
  try{
    let bodyData;
    bodyData= {
    category: "20",
    link: link,
    page:index
    };

var getParams = new URLSearchParams(params);
 const headers = new Headers({
          "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
          'Access-Control-Allow-Credentials': 'true'
      });
var params_str = params.toString();
setLoading(true);
return fetch(url , {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(bodyData)
  })
  .then((response) => {
    if (!response.ok ){
      setLoading(false);
      throw new Error('status is not 200');
    }
    return response.json();
  })
  .then(jsondata => {
    setLoading(false);
    return jsondata;
  })
  .catch(error => {
    setLoading(false);
    return [];
  });;
  }catch{
    setLoading(false);
    return [];
  }
};

  //CREATE action
  const handleCreateUser: MRT_TableOptions<Notice>['onCreatingRowSave'] = async ({
    values,
    table,
  }) => {
    const newValidationErrors = validateUser(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      setMsg("langID00075");
      setMsgOpenErr(true);
      setTimeout(() => {
        setMsgOpenErr(false);
      }, 5000);
      return;
    }
    setValidationErrors({});
    const url = process.env.REACT_APP_RSS_API_URL;
    try {
      let bodyData = {
        category: "0",
        link: values.link,
        interval: values.interval,
        tag: tag,
        image: thumbnail,
        description: values.description,
        content: values.content,
        update_date: values.update_date,
      };
      var getParams = new URLSearchParams(params);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      var params_str = params.toString();
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            setLoading(false);
            throw new Error('status is not 200');
          }
          return response.json();
        })
        .then(jsondata => {
          setLoading(false);
          table.setCreatingRow(false)
        })
        .catch(error => {
          setLoading(false);
        });
      setLoading(false);
    } catch {
      setLoading(false);
    }

  };

  //UPDATE action
  const handleSaveUser: MRT_TableOptions<Notice>['onEditingRowSave'] = async ({
    values,
    table,
    row
  }) => {
    const newValidationErrors = validateUser(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});
    const url = process.env.REACT_APP_RSS_API_URL;
    try {
      let bodyData = {
        category: "1",
        _id: row.original._id,
        link: values.link,
        interval: values.interval,
        tag: tag,
        image: thumbnail,
        description: values.description,
        content: values.content,
        update_date: values.update_date,
      };
      var getParams = new URLSearchParams(params);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      var params_str = params.toString();
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            setLoading(false);
            throw new Error('status is not 200');
          }
          return response.json();
        })
        .then(jsondata => {
          setLoading(false);
          table.setEditingRow(null);
        })
        .catch(error => {
          setLoading(false);
        });
      setLoading(false);
    } catch {
      setLoading(false);
    }

  };

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<Notice>) => {
    if (window.confirm('本当に削除してもよろしいでしょうか')) {
      const url = process.env.REACT_APP_RSS_API_URL;
      try {
        let bodyData = {
          category: "2",
          _id: row.original._id,
          link: row.original.link
        };
        var getParams = new URLSearchParams(params);
        const headers = new Headers({
          "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
          'Access-Control-Allow-Credentials': 'true'
        });
        var params_str = params.toString();
        setLoading(true);
        return fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(bodyData)
        })
          .then((response) => {
            if (!response.ok) {
              setLoading(false);
              throw new Error('status is not 200');
            }
            return response.json();
          })
          .then(jsondata => {
            setLoading(false);
          })
          .catch(error => {
            setLoading(false);
          });
        setLoading(false);
      } catch {
        setLoading(false);
      }
    }
  };
  const options = [
    { value: 'tag1', label: 'タグ1' },
    { value: 'tag2', label: 'タグ2' },
    { value: 'tag3', label: 'タグ3' },
    { value: 'tag4 ', label: 'タグ4' },
  ];
  const options2 = [
    { value: "30", label: '30分' },
    { value: "60", label: '1時間' },
    { value: "240", label: '4時間' },
    { value: "1440", label: '24時間' },
  ];
  const options3 = [
    { value: "description", label: 'description' },
    { value: "content", label: 'content' },
  ];
  const options4 = [
    { value: "description", label: 'description' },
    { value: "content", label: 'content' },
    { value: "both", label: '両方' },
  ];


  const columns = useMemo<MRT_ColumnDef<Notice>[]>(
    //column definitions...
    () => [
      {
        accessorKey: 'link',
        header: 'RSSリンク',
        size: 250,
        grow: false,
        muiEditTextFieldProps: {
          sx: { width: 1 / 2 }
        },
      },
      {
        accessorKey: 'interval',
        header: '取り込み間隔',
        size: 50,
        grow: false,
        editVariant: 'select',
        editSelectOptions: options2,
        muiEditTextFieldProps: {
          select: true,
          sx: { width: 1 / 4, display: 'flex' }
        },
      },
      // {
      //   accessorKey: 'tag',
      //   header: 'タグ',
      //   size: 50,
      //   grow: false,
      //   editVariant: 'select',
      //   editSelectOptions: options,
      //   muiEditTextFieldProps: {
      //     select: true,
      //     sx:{ width: 1/4,display: 'flex' }
      //   },
      // },
      // {
      //   accessorKey: 'image',
      //   header: '画像',
      //   size: 250,
      //   grow: false,
      //   editVariant: 'image',
      //   muiEditTextFieldProps: {
      //     sx:{ width: 1/2 }
      //   },
      // },
      {
        accessorKey: 'description',
        header: '説明',
        size: 50,
        grow: false,
        editVariant: 'select',
        editSelectOptions: options3,
        muiEditTextFieldProps: {
          select: true,
          sx: { width: 1 / 4, display: 'flex' }
        },
      },
      {
        accessorKey: 'content',
        header: '本文',
        size: 50,
        grow: false,
        editVariant: 'select',
        editSelectOptions: options4,
        muiEditTextFieldProps: {
          select: true,
          sx: { width: 1 / 4, display: 'flex' }
        },
      },
      {
        accessorKey: 'update_date',
        header: '最終更新日',
        size: 150,
        grow: false,
        focus: true,
        muiEditTextFieldProps: {
          type: 'datetime-local',
          inputProps: {
            step: 300,
          },
          sx: { width: 1 / 4, display: 'flex' },
          InputLabelProps: { shrink: true },
        },
      },




    ],
    [posts],
  );

  const data = posts
  const table = useMaterialReactTable({
    columns,
    data,
    enableEditing: true,
    createDisplayMode: 'modal',
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    onCreatingRowSave: handleCreateUser,
    onCreatingRowCancel: () => {
      //clear any validation errors
    },
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleSaveUser,
    positionCreatingRow: 'top', //default is 'top'
    defaultColumn: {
      // minSize: 1100,
      // width:"100%"
    },
    enableDensityToggle: false,
    enableColumnResizing: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableClickToCopy: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    paginationDisplayMode: 'pages',
    enableSorting: false,
    autosizeColumns: "none",
    localization: locale,
    muiEditRowDialogProps: {
      maxWidth: 'xl'
    },
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
      columnVisibility: { tag: false, image: false }
    },
    muiDetailPanelProps: () => ({
    }),
    //custom expand button rotation
    muiExpandButtonProps: ({ row, table }) => ({
      onClick: () => table.setExpanded({ [row.id]: !row.getIsExpanded() }), //only 1 detail panel open at a time
      sx: {
      },
    }),
    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">追加</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'row', gap: '1rem', flexWrap: 'wrap' }}
        >
          <Typography >
            <input id="img" type="file" accept="image/*,.png,.jpg,.jpeg,.gif,.svg,.ico" onChange={getImage} />
            <input hidden type="button" value="保存" onClick={handleUpload} />
            {thumbnail != "" && <img
              height={90}
              width={90}
              src={thumbnail}
              loading="lazy"
            />}
            <br />タグ<br />
            <Button variant="contained" onClick={tagManage} color="secondary" sx={{ width: "150px" }}>タグ管理</Button><br />
            <FormControl sx={{ m: 1, width: 800, marginLeft: "-0px" }}>
              <InputLabel id="demo-multiple-chip-label"></InputLabel>
              <Select sx={{ height: 70 }}
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                value={tag}
                placeholder="タグ"
                onChange={tagChange}
                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {data3.map(v => v.name).map((name) => (
                  <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, tag, theme)}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Typography>
          {internalEditComponents} {/* or render custom edit components here */}
          {preTitle != "" && 
          <div><b>プレビュー</b><br />
          タイトル：{preTitle}<br />
          説明：{preDescription}<br />
          本文：{preContent}<br />
          リンク：{preLink}<br /></div>
         }
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {

              const feed =  getRssFunc(row._valuesCache.link);
              //console.log(text);


            }}
          >
            プレビュー
          </Button>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    //optionally customize modal content
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">更新</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'row', gap: '1rem', flexWrap: 'wrap' }}
        >
          <Typography>
            <input id="img" type="file" accept="image/*,.png,.jpg,.jpeg,.gif,.svg,.ico" onChange={getImage} />
            <input hidden type="button" value="保存" onClick={handleUpload} />
            {thumbnail != "" && <img
              height={90}
              width={90}
              src={thumbnail}
              loading="lazy"
            />}
            <br />タグ<br />
            <Button variant="contained" onClick={tagManage} color="secondary" sx={{ width: "150px" }}>タグ管理</Button><br />
            <FormControl sx={{ m: 1, width: 800, marginLeft: "-0px" }}>
              <InputLabel id="demo-multiple-chip-label"></InputLabel>
              <Select sx={{ height: 70 }}
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                value={tag}
                placeholder="タグ"
                onChange={tagChange}
                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {data3.map(v => v.name).map((name) => (
                  <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, tag, theme)}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Typography>
          {internalEditComponents} {/* or render custom edit components here */}
          {preTitle != "" && 
          <div><b>プレビュー</b><br />
          タイトル：{preTitle}<br />
          説明：{preDescription}<br />
          本文：{preContent}<br />
          リンク：{preLink}<br /></div>
         }
        </DialogContent>
        <DialogActions>
                    <Button
            variant="contained"
            color="secondary"
            onClick={() => {

              const feed =  getRssFunc(row._valuesCache.link);
              //console.log(text);


            }}
          >
            プレビュー
          </Button>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Edit">
          <IconButton onClick={() => {
            table.setEditingRow(row);
            setThumbnail(row.original.image);
            setTag(row.original.tag);
            setPreTitle("");
            setPreContent("");
            setPreDescription("");
            setPreLink("");
          }
          }>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            setPage(1);
            setPageCount(1);
            const data4 = getFeed(row.original.link,1);
            setOpen5(true);
            setLink(row.original.link);
          }}
        >
          詳細
        </Button>
      </Box>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      <Button
        variant="contained"
        onClick={() => {
          table.setCreatingRow(true);
          setThumbnail("");
          setTag([]);
          setPreTitle("");
          setPreContent("");
          setPreDescription("");
          setPreLink("");
          //simplest way to open the create row modal with no default values
          //or you can pass in a row object to set default values with the `createRow` helper function
          // table.setCreatingRow(
          //   createRow(table, {
          //     //optionally pass in default values for the new row, useful for nested data or other complex scenarios
          //   }),
          // );
        }}
      >
        追加
      </Button>
    ),
  });
  const columns2 = useMemo<MRT_ColumnDef<Tag>[]>(
    //column definitions...
    () => [
      {
        accessorKey: 'name',
        header: '',
        size: 500,
        grow: false,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.name,
          helperText: validationErrors?.name,
          //remove any previous validation errors when user focuses on the input
          //optionally add validation checking for onBlur or onChange
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              name: undefined,
            }),
        },
      },
    ],
    [posts3],
  );

    const columns3 = useMemo<MRT_ColumnDef<Notice>[]>(
    //column definitions...
    () => [
      {
        accessorKey: 'title',
        header: 'タイトル',
        size: 250,
        grow: false,
        muiEditTextFieldProps: {
          sx: { width: 1 / 2 }
        },
      },
      // {
      //   accessorKey: 'tag',
      //   header: 'タグ',
      //   size: 50,
      //   grow: false,
      //   editVariant: 'select',
      //   editSelectOptions: options,
      //   muiEditTextFieldProps: {
      //     select: true,
      //     sx:{ width: 1/4,display: 'flex' }
      //   },
      // },
      // {
      //   accessorKey: 'image',
      //   header: '画像',
      //   size: 250,
      //   grow: false,
      //   editVariant: 'image',
      //   muiEditTextFieldProps: {
      //     sx:{ width: 1/2 }
      //   },
      // },
      {
        accessorKey: 'description',
        header: '説明',
        size: 250,
        grow: false,
        muiEditTextFieldProps: {
          sx: { width: 1 / 2 }
        },
      },
      {
        accessorKey: 'content',
        header: '本文',
        size: 50,
        grow: false,
        editVariant: 'select',
        editSelectOptions: options4,
        muiEditTextFieldProps: {
          select: true,
          sx: { width: 1 / 4, display: 'flex' }
        },
      },
      {
        accessorKey: 'update_time',
        header: '最終更新日',
        size: 150,
        grow: false,
        focus: true,
        muiEditTextFieldProps: {
          type: 'datetime-local',
          inputProps: {
            step: 300,
          },
          sx: { width: 1 / 4, display: 'flex' },
          InputLabelProps: { shrink: true },
        },
      },




    ],
    [posts3],
  );

  const data3 = posts3
  const table2 = useMaterialReactTable({
    columns: columns2,
    data: data3,
    enableEditing: true,
    createDisplayMode: 'modal',
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    onCreatingRowSave: handleCreateUser2,
    onCreatingRowCancel: () => {
      //clear any validation errors
    },
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleSaveUser2,
    positionCreatingRow: 'top', //default is 'top'
    defaultColumn: {
      // minSize: 1100,
      // width:"100%"
    },
    enableDensityToggle: false,
    enableColumnResizing: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableClickToCopy: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    paginationDisplayMode: 'pages',
    enableSorting: false,
    autosizeColumns: "none",
    localization: locale,
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    muiDetailPanelProps: () => ({
    }),
    //custom expand button rotation
    muiExpandButtonProps: ({ row, table }) => ({
      onClick: () => table.setExpanded({ [row.id]: !row.getIsExpanded() }), //only 1 detail panel open at a time
      sx: {
      },
    }),
    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">追加</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    //optionally customize modal content
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">更新</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Edit">
          <IconButton onClick={
            () => {
              table.setEditingRow(row);
              setThumbnail(row.original.image);
              setTag(row.original.tag)
              setPreTitle("");
              setPreContent("");
              setPreDescription("");
              setPreLink("");

            }
          }>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton color="error" onClick={() => openDeleteConfirmModal2(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      <Button
        variant="contained"
        onClick={() => {
          table.setCreatingRow(true); //simplest way to open the create row modal with no default values
          //or you can pass in a row object to set default values with the `createRow` helper function
          // table.setCreatingRow(
          //   createRow(table, {
          //     //optionally pass in default values for the new row, useful for nested data or other complex scenarios
          //   }),
          // );
        }}
      >
        追加
      </Button>
    ),
  });
    //DELETE action
  const openDeleteConfirmModal3 = (row: MRT_Row<User>) => {
    if (window.confirm('本当に削除してもよろしいでしょうか')) {
      const url = process.env.REACT_APP_RSS_API_URL;
      try {
        let bodyData = {
          category: "21",
          _id: row.original._id
        };
        var getParams = new URLSearchParams(params);
        const headers = new Headers({
          "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
          'Access-Control-Allow-Credentials': 'true'
        });
        var params_str = params.toString();
        setLoading(true);
        return fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(bodyData)
        })
          .then((response) => {
            if (!response.ok) {
              setLoading(false);
              throw new Error('status is not 200');
            }
            return response.json();
          })
          .then(jsondata => {
            setLoading(false);
            getTag();
          })
          .catch(error => {
            setLoading(false);
          });
        setLoading(false);
      } catch {
        setLoading(false);
      }
    }
  };


  const data4 = posts2
  const table3 = useMaterialReactTable({
    columns: columns3,
    data: data4,
    enableEditing: true,
    onCreatingRowCancel: () => {
      //clear any validation errors
    },
    onEditingRowCancel: () => setValidationErrors({}),
    positionCreatingRow: 'top', //default is 'top'
    defaultColumn: {
      // minSize: 1100,
      // width:"100%"
    },
    enableDensityToggle: false,
    enableColumnResizing: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableClickToCopy: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enablePagination: false,
    enableResizing: false,
    paginationDisplayMode: 'pages',
    enableSorting: false,
    autosizeColumns: "none",
    localization: locale,
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    muiDetailPanelProps: () => ({
    }),
    
    //custom expand button rotation
    muiExpandButtonProps: ({ row, table }) => ({
      onClick: () => table.setExpanded({ [row.id]: !row.getIsExpanded() }), //only 1 detail panel open at a time
      sx: {
      },
    }),
        renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Delete">
          <IconButton color="error" onClick={() => 
            {
              openDeleteConfirmModal3(row);
              getFeed(row.original.feed_url,1)
            }
            }>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  });

  return (
    <Box noWrap
      id="hero"
      sx={(theme) => ({
        //width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    ><div className={auth ? '' : 'hidden'} style={{ visibility: auth ? "visible" : "hidden" }}>
        <Container maxWidth="xl"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pt: { xs: 0, sm: 13 },
            pb: { xs: 0, sm: 0 },
          }}
        >
          <InputLabel htmlFor="email-hero" sx={visuallyHidden} >
          </InputLabel>
          {/* <Container maxWidth={false}>
            <TextField
              id="email-hero"
              hiddenLabel
              fullWidth
              variant="outlined"
              placeholder="キーワード検索（#を付けて検索するとタグを検索します）"
              //value={location.state["keyword"]}
              defaultValue={keyword}
              autoComplete= 'off'
              InputProps={{ endAdornment: <AddButton /> }}
              onChange={handleChangeInput}
              sx={{ height:60}}
              onKeyDown={e => {
                  reloadChange();
              }}
            />
            <div>
            </div>
            </Container> */}
          <Typography
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 0.5,
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
            }}
          >

          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: '100%', sm: 'auto' } }}
          ></Stack>
          <Link hidden id="sc" to={"/search?" + getParams} state={{ keyword: keyword, category: category }}>テキスト</Link>
        </Container>
        <input type="hidden" name="recaptcha_response" id="recaptchaResponse"></input>
        <Container maxWidth="xl"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <br />
          <Container maxWidth="xl"
            sx={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Typography variant="h5" gutterBottom>ニュースメンテナンス</Typography>
            <Link hidden id="createColumn" to={"/ColumnDetail"} state={{ keyword: keyword, category: "new", bf: "ad", table: { none: "none" } }}>テキスト</Link>
          </Container>
          <MaterialReactTable noWrap table={table} />
          <Dialog
            open={open4}
            onClose={handleDialogClose4}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <Stack my={1} direction="row" justifyContent="end" spacing={1}>
                <IconButton aria-label="delete" onClick={handleDialogClose4} sx={{ zIndex: 10000 }} >
                  <CloseIcon />
                </IconButton>
              </Stack>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <MaterialReactTable table={table2} />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
            </DialogActions>
          </Dialog>
          <Dialog
            maxWidth="xl"
            open={open5}
            onClose={handleDialogClose5}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <Stack my={1} direction="row" justifyContent="end" spacing={1}>
                <IconButton aria-label="delete" onClick={handleDialogClose5} sx={{ zIndex: 10000 }} >
                  <CloseIcon />
                </IconButton>
              </Stack>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <MaterialReactTable table={table3} />
                      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 4, }}>
                        <Pagination  hidePrevButton hideNextButton count={pageCount} page={page} onChange={handleChangePage} />
                      </Box>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
            </DialogActions>
          </Dialog>


        </Container>
      </div>
    </Box>
  );
}